<div class="auth-flow" *ngIf="authState$ | async as authState">
    <!-- Wait until loading is complete to avoid FOUC -->
    <ng-container *ngIf="!authState.loading">
        <!-- Logged-out state -->
        <button *ngIf="!authState.isAuthenticated" class="login-btn" (click)="login()">Log in</button>

        <!-- Logged-in state -->
        <div *ngIf="authState.isAuthenticated" class="user-dropdown">
            <img class="avatar" [src]="authState.user.picture || 'assets/default-avatar.png'" [alt]="authState.user.name" (click)="toggleDropdown()" />
            <div class="dropdown-menu" [class.show]="dropdownOpen">
                <div class="details">
                    <!-- <div class="name">{{ authState.user.name }}</div> -->
                    <div class="email">{{ authState.user.email }}</div>
                </div>
                <button class="logout-btn" (click)="logout()">Log out</button>
            </div>
        </div>
    </ng-container>
</div>